import type { ReactNode } from 'react';

interface UserBubbleProps {
  children: ReactNode;
}

export function UserBubble({ children }: UserBubbleProps) {
  return (
    <div className="bg-white border border-slate-200 text-slate-800 rounded-2xl px-4 py-3 max-w-[85%] self-end text-[14.5px] leading-snug shadow-sm whitespace-pre-wrap break-words deep-dive-slide-fade">
      {children}
    </div>
  );
}
